module.exports = __webpack_public_path__ + "img/pin-navy.293587d3.svg";